import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { 
      code: 'fr', 
      name: 'Français', 
      flag: 'https://flagcdn.com/w40/fr.png'
    },
    { 
      code: 'en', 
      name: 'English (Canadian)', 
      flag: 'https://flagcdn.com/w40/ca.png'
    },
    { 
      code: 'ar', 
      name: 'العربية', 
      flag: 'https://flagcdn.com/w40/tn.png'
    },
    { 
      code: 'zh', 
      name: '中文', 
      flag: 'https://flagcdn.com/w40/cn.png'
    },
    { 
      code: 'ja', 
      name: '日本語', 
      flag: 'https://flagcdn.com/w40/jp.png'
    },
    { 
      code: 'es', 
      name: 'Español', 
      flag: 'https://flagcdn.com/w40/es.png'
    },
    { 
      code: 'it', 
      name: 'Italiano', 
      flag: 'https://flagcdn.com/w40/it.png'
    }
  ];

  const currentLang = languages.find(l => l.code === language);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-sm border border-[#C9A227] hover:bg-[#C9A227]/10 transition-colors"
        data-testid="language-switcher"
      >
        <img 
          src={currentLang?.flag} 
          alt={currentLang?.name}
          className="w-6 h-4 object-cover rounded-sm"
        />
        <span className="text-sm font-medium text-[#1A1A1A] hidden sm:inline">{currentLang?.code.toUpperCase()}</span>
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 bg-white border border-[#F5EFD3] shadow-lg z-50 min-w-[150px]">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => {
                setLanguage(lang.code);
                setIsOpen(false);
              }}
              className={`w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-[#FDFCF8] transition-colors ${
                language === lang.code ? 'bg-[#FDFCF8] text-[#C9A227]' : 'text-[#1A1A1A]'
              }`}
              data-testid={`lang-${lang.code}`}
            >
              <img 
                src={lang.flag} 
                alt={lang.name}
                className="w-6 h-4 object-cover rounded-sm"
              />
              <span className="text-sm">{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
